import { Component } from "react";
import { Switch } from "react-router";
import { BusPublicPage } from "../pages/bus-public-page/BusPublicPage";
import { TrainContactPage } from "../pages/train-contact-page/TrainContactPage";
import { TrainPublicPage } from "../pages/train-public-page/TrainPublicPage";
import { BusLayout } from "./BusLayout";
import { RouteWithLayout } from "./RouteWithLayout";
import { TrainLayout } from "./TrainLayout";
import { TrainSurchargePage } from "../pages/train-surcharge-page/TrainSurchargePage";
import { TrainPublicPageNew } from "../pages/train-public-page/new-forms/TrainPublicPageNew";

export class TrainDefaultSwitch extends Component {
  render() {
    return (
      <Switch>
        {/* <RouteWithLayout layout={TrainLayout} exact path="/" component={TrainPublicPage} /> */}
        {/* <RouteWithLayout layout={TrainLayout} exact path="/public" component={TrainPublicPage} /> */}
        <RouteWithLayout layout={BusLayout} exact path="/buses" component={BusPublicPage} />
        {/* <RouteWithLayout layout={TrainLayout} exact path="/trains" component={TrainPublicPage} /> */}
        <RouteWithLayout layout={TrainLayout} exact path="/trains/contact" component={TrainContactPage} />
        <RouteWithLayout layout={TrainLayout} exact path="/trains/surcharge" component={TrainSurchargePage} />
        <RouteWithLayout layout={TrainLayout} exact path="/trains/evf" component={TrainPublicPageNew} />
      </Switch>
    );
  }
}
